import Vue from "vue";
import Router from "vue-router";
import {routers} from "./router";
//此VueRouter是自己自定义引入暴露出来的，即是自定义的，以下的VueRouter同样是这样
// 解决两次访问相同路由地址报错（通常这不是必要的，但保留以供参考）  
const originalPush = Router.prototype.push;  
Router.prototype.push = function push(location) {  
  return originalPush.call(this, location).catch(err => {  
    console.error('Error in router push:', err); // 打印错误到控制台  
    return err;  
  });  
};  
  
Vue.use(Router); 
// 路由配置
const RouterConfig = {  
  mode: "hash",  
  routes: routers  
};  
/**
 * 重写路由的push方法
 */

const router = new Router(RouterConfig);

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  const token = window.sessionStorage.getItem("token");  
  // 检查是否需要登录：这里假设除了登录页面外，其他页面都需要验证token  
  if (to.path !== '/login' && !token) {  
    // 如果没有token并且目标路由不是登录页面，则重定向到登录页面  
    next('/login');  
  } else {  
    // 如果有token或者目标路由是登录页面，则直接前往目标路由  
    next();  
  }  
});

export default router;
